export default "__VITE_ASSET__BWK_MF1R__"